import { render } from "./policyPhoto.vue?vue&type=template&id=739a90c9"
import script from "./policyPhoto.vue?vue&type=script&lang=js"
export * from "./policyPhoto.vue?vue&type=script&lang=js"

import "./policyPhoto.vue?vue&type=style&index=0&id=739a90c9&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__